// A tool's code and data are requested only near its position in the article.
const loaders = { 'life-simulator': () => import('../../Tools/LifeSimulator/life-simulator.js') };
const pending = new Map();
async function load(host) {
  const id = host.dataset.cbTool;
  try {
    if (!pending.has(id)) pending.set(id, loaders[id]());
    await pending.get(id);
  } catch {
    pending.delete(id);
    const status = host.querySelector('.cb-tool-loading');
    if (status) status.textContent = 'The simulator could not be loaded. Please refresh the page to try again.';
  }
}
const hosts = document.querySelectorAll('[data-cb-tool]');
if ('IntersectionObserver' in window) {
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) if (entry.isIntersecting) { observer.unobserve(entry.target); load(entry.target); }
  }, { rootMargin: '400px' });
  hosts.forEach(host => { if (loaders[host.dataset.cbTool]) observer.observe(host); });
} else hosts.forEach(host => { if (loaders[host.dataset.cbTool]) load(host); });
